import env from 'env-var'

export default Object.freeze({
  env: env.get('NODE_ENV').default('development').asString(),
  enableRequestLogsDev: env.get('REACT_APP_REQUESTS_LOGS_ENABLED').asBool()
})
